import Loading from "../../../components/Loading";
import { arrayMap, findItemByFiled } from "../../../utils/array.utils";
import { useGetGroupCarInfoQuery } from "../../../utils/carInfo.utils";
import { useGetAllCarInfoTypeQuery } from "../../../utils/carInfoType.utils";
import { RenderFields, optionGen } from "../../../utils/form.utils";
import { locationNeedDateInput } from "../../../utils/stockList.utils";
import { textCamelCase } from "../../../utils/string.utils";

export default function LocationField({ watch, control, errors, setValue }) {
  const locationOnChange = locationNeedDateInput.includes(watch("location")?.label);

  const { loading: parentLoading, data: parentData } = useGetGroupCarInfoQuery({
    query: ``,
    key: `GetParentGroupCarInfoForStockListAdd`
  });

  const { loading: typeLoading, data: typeData } = useGetAllCarInfoTypeQuery({
    query: ``,
    key: `GetTypeDataForStockListAdd`
  });

  function handleTypeId(slug) {
    return typeData?.length ? findItemByFiled(typeData, "slug", slug)?.id : null;
  }

  let typeIds = {};

  const typeSlugs = arrayMap(typeData, (item) => item?.slug) || [];

  typeSlugs.forEach((element) => {
    typeIds[textCamelCase(element)] = handleTypeId(element);
  });

  function handleParentData(name) {
    return parentData[name] ? optionGen(parentData[name]) : [];
  }

  const locationOptions = handleParentData("car-location");

  let fields = [
    {
      label: "Location",
      name: "location",
      type: "select",
      placeholder: "Select a location",
      col: { md: 12 },
      options: locationOptions
    }
  ];

  if (locationOnChange) {
    fields.push({
      label: "ETA Date",
      name: "eta_date",
      type: "date",
      placeholder: "Select a date",
      col: { md: 12 }
    });
  }

  const isLoading = typeLoading || parentLoading;

  return (
    <>
      <Loading loading={isLoading} />
      {
        <RenderFields
          setValue={setValue}
          fields={fields}
          control={control}
          watch={watch}
          errors={errors}
        />
      }
    </>
  );
}
